export enum AssessmentStatusEnum {
  Draft = 'draft',
  Active = 'active',
  Closed = 'closed',
}
